<template>
    <div>
      <a-button @click="filterView" icon="info-circle" style="margin-right: 20px">达标条件说明</a-button>
      <a-button @click="filterConfig" type="primary" icon="setting">达标条件配置</a-button>
      <a-drawer
        title="达标条件"
        placement="right"
        :maskClosable="false"
        :visible="visible"
        width="1000"
        @close="onClose"
      >
        <a-table
          ref="table"

          size="middle"
          rowKey="id"
          :columns="configColumns"
          :dataSource="configData"
          :pagination="false"
          :loading="loading"
         >
            <span slot="action" slot-scope="text, record, index">
                <a @click="handleConfig(record, index)">配置</a>
              </span>
          <span slot="formInfo" slot-scope="text, record, index">
                <div v-if="!record.formInfoList || record.formInfoList.length==0">
                  暂未配置，默认任一表单提交（包括失访提交和数据缺失）即算作完成随访以及完成达标随访。
                </div>
             <div v-else>
                <div style="margin-bottom: 10px">
                  当以下表单
                <label style="color: red">{{record.type==='1'?'任一':'全部'}}</label>
                提交时，算作完成随访；当伴随条件都满足时，算作达标。
                </div>
            <a-table
              ref="table2"

              size="small"
              rowKey="id"
              :columns="formColumns"
              :dataSource="record.formInfoList"
              :pagination="false"
              :loading="loading"
            >
            <span slot="allow3" slot-scope="text, record, index">
                <label :style="{color: text==='1'?'green':'red'}">
                  {{text==='1'?'√':'×'}}
                </label>
              </span>
          <span slot="allow5" slot-scope="text, record, index">
                <label :style="{color: text==='1'?'green':'red'}">
                  {{text==='1'?'√':'×'}}
                </label>
          </span>
        </a-table>
             </div>
          </span>
        </a-table>
      </a-drawer>
      <a-modal
        title="用户列表"
        :width="1000"
        :visible="visible2"
        :confirmLoading="loading"
        @ok="handleSubmit"
        @cancel="handleCancel">
        <div style="margin-bottom: 10px">
          当以下表单
          <a-select v-model="currentFormInfo.type" style="width: 80px">
            <a-select-option
              value="1">
              任一
            </a-select-option>
            <a-select-option
              value="2">
              全部
            </a-select-option>
          </a-select>
          提交时，算作完成随访；当伴随条件都满足时，算作达标。
        </div>
        <a-table

          size="middle"
          rowKey="id"
          :columns="formItemColumns"
          :pagination="false"
          :dataSource="formItemData"
          :loading="loading"
          >
          <span slot="checked" slot-scope="text, record, index">
            <a-checkbox :checked="record.checked==='1'" @change="checkedChange('checked',record,$event)">

              </a-checkbox>
          </span>
          <span slot="allow3" slot-scope="text, record, index">
              <a-checkbox :checked="record.allow3==='1'" @change="checkedChange('allow3',record,$event)">

              </a-checkbox>
          </span>
          <span slot="allow5" slot-scope="text, record, index">
              <a-checkbox :checked="record.allow5==='1'" @change="checkedChange('allow5',record,$event)">

              </a-checkbox>
          </span>
        </a-table>
      </a-modal>
    </div>
</template>

<script>
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  export default {
    name: 'StandardFilter',
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        visible: false,
        visible2:false,
        loading:false,
        formItemData:[],
        formItemColumns:[
          {
            title: '选择',
            align: "center",
            dataIndex: 'checked',
            scopedSlots: {customRender: 'checked'},
          },
          {
            title: '表单名称',
            align: "center",
            dataIndex: 'formName',
          },
          {
            title: '允许数据缺失',
            align: "center",
            dataIndex: 'allow3',
            scopedSlots: {customRender: 'allow3'},
            width: 200,
          },
          {
            title: '允许失访提交',
            align: "center",
            scopedSlots: {customRender: 'allow5'},
            dataIndex: 'allow5',
            width:200,
          },
        ],
        configData:[],
        configColumns:[],
        configBaseColumns:[
          {
            title: '周期',
            align: "center",
            dataIndex: 'periodItemName',
            width: 200,
          },
          {
            title: '表单',
            align: "center",
            dataIndex: 'formInfo',
            scopedSlots: {customRender: 'formInfo'},
          },
        ],
        formColumns:[
          {
            title: '表单名称',
            align: "center",
            dataIndex: 'formName',
          },
          {
            title: '允许数据缺失',
            align: "center",
            dataIndex: 'allow3',
            scopedSlots: {customRender: 'allow3'},
            width: 120,
          },
          {
            title: '允许失访提交',
            align: "center",
            scopedSlots: {customRender: 'allow5'},
            dataIndex: 'allow5',
            width:120,
          },
        ],
        currentFormInfo:{},
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.loading = true
        getAction('/project/statistic/visitRate/standardFilter',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.configData = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      filterView(){
        this.configColumns = JSON.parse(JSON.stringify(this.configBaseColumns))
        this.visible = true;

      },
      filterConfig(){
        const configColumns = JSON.parse(JSON.stringify(this.configBaseColumns))
        configColumns.push({
          title: '操作',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'action'},
        })
        this.configColumns = configColumns
          this.visible = true;

      },
      onClose(){
        this.visible = false;
      },
      handleConfig(record){
        this.currentFormInfo = record
        this.loadFormItemData()
      },
      loadFormItemData(){
        getAction('/project/statistic/visitRate/getFormInfo',{periodItemId:this.currentFormInfo.periodItemId}).then(res=>{
          if(res.success){
            const formItemData = []
            res.result.forEach(form=>{
              const newForm = {
                id:form.id,
                formName:form.name,
                allow3:'0',
                allow5:'0',
                checked:'0',
              }
              // 回显
              if(this.currentFormInfo.formInfoList){
                this.currentFormInfo.formInfoList.forEach(baseForm=>{
                  if(baseForm.id===form.id){
                    newForm.allow3 = baseForm.allow3
                    newForm.allow5 = baseForm.allow5
                    newForm.checked = '1'
                  }
                })
              }
              formItemData.push(newForm)
            })
            this.formItemData = formItemData
          }
        }).finally(()=>{
          this.visible2 = true
        })
      },
      handleSubmit(){
        const formItemData = []
        this.formItemData.forEach(formItem=>{
          if(formItem.checked==='1'){
            formItemData.push({
              id:formItem.id,
              formName:formItem.formName,
              allow3:formItem.allow3,
              allow5:formItem.allow5,
            })
          }
        })
        const params = {
          id:this.currentFormInfo.id,
          type:this.currentFormInfo.type,
          formInfo:JSON.stringify(formItemData)
        }
        this.loading = true
        postAction('/project/statistic/visitRate/submitFormInfo',params).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.handleCancel()
            this.loadData();
            this.$emit('loadData')
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleCancel(){
        this.currentFormInfo = {}
        this.visible2 = false
      },
      checkedChange(key,record,e){
        if(e.target.checked){
          record[key] = '1'
        }else{
          record[key] = '0'
        }
      },
    }
  }
</script>

<style scoped>

</style>